import { useState, useEffect, useRef } from "react";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { noteRound } from "../../../../util/DoubleUtil";
import { rltAtaFinalTurmaWebV2 } from "../../api-relatorio";
import { findByTurma } from "../../../AlunoTurma/api-aluno-turma";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { useLocation } from "react-router";

const useStyles = makeStyles({
  paper: {
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  showRI: {},
  hideRI: {
    display: "none",
  },
  notaVermelha: {
    color: "red",
  },
});

export default function RelatorioAtaFinalTurmaWebV2() {
  const [listaAFT, setListaAFT] = useState([]);
  const [listaAT, setListaAT] = useState([]);
  const location = useLocation();
  const codTurma = location.state.codTurma;
  const classes = useStyles();
  const progress = useRef(0);

  useEffect(() => {
    findByTurma(codTurma).then((data) => {
      if (data.error) {
        console.log(data);
      } else {
        setListaAT(data);
      }
    });
  }, [codTurma]);

  useEffect(() => {
    async function asyncAFTReport() {
      while (progress.current < listaAT.length) {
        await rltAtaFinalTurmaWebV2(listaAT[progress.current].codigo).then(
          (data) => {
            if (data.error) {
              console.log(data);
            } else {
              console.log(data);
              setListaAFT((prevState) => [...prevState, data]);
            }
            progress.current = progress.current + 1;
          },
        );
      }
    }
    asyncAFTReport();

    // eslint-disable-next-line
  }, [listaAT]);

  return (
    <Container maxWidth={false} className={classes.paper} component={Paper}>
      <Typography
        style={{
          textAlign: "center",
          textDecoration: "underline",
          marginBottom: "40px",
        }}
        variant="h6"
      >
        Ata Final Turma V2
      </Typography>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2}>RM</TableCell>
            <TableCell rowSpan={2}>N. Chamada</TableCell>
            <TableCell rowSpan={2}>Nome</TableCell>
            {listaAFT.length > 0 ? (
              <>
                {listaAFT[0].listaAF.map((af) => (
                  <>
                    <TableCell>{af.tdp.disciplina.descricao}</TableCell>
                  </>
                ))}
              </>
            ) : (
              ""
            )}
          </TableRow>
          <TableRow>
            {listaAFT.length > 0 ? (
              <>
                {listaAFT[0].listaAF.map(() => (
                  <>
                    <TableCell>Média Final</TableCell>
                  </>
                ))}
              </>
            ) : (
              ""
            )}
          </TableRow>
        </TableHead>

        <TableBody>
          {listaAFT.map((aft, index) => (
            <>
              <TableRow key={index}>
                <TableCell>{aft.alunoTurma.aluno.codAlunoEscola}</TableCell>
                <TableCell>{aft.alunoTurma.numeroChamada}</TableCell>
                <TableCell>{aft.alunoTurma.aluno.nome}</TableCell>
                {aft.listaAF.map((af) => (
                  <>
                    <TableCell
                      className={
                        af.mediaFinal &&
                        af.mediaFinal.nota &&
                        af.mediaFinal.nota < 6
                          ? classes.notaVermelha
                          : ""
                      }
                    >
                      {af.mediaFinal && af.mediaFinal.nota
                        ? noteRound(af.mediaFinal.nota)
                        : "--"}
                    </TableCell>
                  </>
                ))}
              </TableRow>
            </>
          ))}
        </TableBody>
      </Table>

      <LinearProgressWithLabel
        value={((progress.current + 1) * 100) / listaAT.length}
      />
    </Container>
  );
}

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};
